import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardContent: {
      padding: theme.spacing(2),
      paddingTop: '0px !important',
      justifyContent: 'space-between',
      // height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    dataTableWithoutHeader: {
      minHeight: '0px',
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      '& [class^="MuiToolbar-root-"]': {
        paddingLeft: '10px !important',
        paddingRight: '0px !important'
      }
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    cardTitle: {
      fontSize: '1.2rem',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 400,
      lineHeight: 1.2,
      letterSpacing: '-0.00833em',
      paddingLeft: '0px !important',
      paddingRight: '0px !important'
    },
    cardheader: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      marginLeft: '0px !important'
    }
  })
